var map = {
	"./baac.svg": 626,
	"./bay.svg": 627,
	"./bbl.svg": 628,
	"./bnp.svg": 629,
	"./boa.svg": 630,
	"./cacib.svg": 631,
	"./cimb.svg": 632,
	"./citi.svg": 633,
	"./db.svg": 634,
	"./ghb.svg": 635,
	"./gsb.svg": 636,
	"./hsbc.svg": 637,
	"./ibank.svg": 638,
	"./icbc.svg": 639,
	"./jpm.svg": 640,
	"./kbank.svg": 641,
	"./kk.svg": 642,
	"./ktb.svg": 643,
	"./lhb.svg": 644,
	"./mb.svg": 645,
	"./mega.svg": 646,
	"./mufg.svg": 647,
	"./rbs.svg": 648,
	"./sc.svg": 649,
	"./scb.svg": 650,
	"./smbc.svg": 651,
	"./tbank.svg": 652,
	"./tcrb.svg": 653,
	"./tisco.svg": 654,
	"./tmb.svg": 655,
	"./uob.svg": 656
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 79
// module chunks = 1